import Glide from '@glidejs/glide';

document.addEventListener('DOMContentLoaded', () => {

  // 1) Banner principal
  const banner = document.querySelector('.glide--banner');
  if (banner) {
    const glideBanner = new Glide(banner, {
      type: 'carousel',
      autoplay: 5000,
      perView: 1,
      peek: 0,
      gap: 0,
      startAt: 0,    // garante começar no slide 0
    });

    glideBanner.mount();

    window.addEventListener('load', () => {
      glideBanner.update(); // força recalculo das dimensões
    });
  }

  // 2) Slider de lançamentos
  const lancamentos = document.querySelector('.glide--lancamentos');
  if (lancamentos) {
    new Glide(lancamentos, {
      type: 'carousel',
      autoplay: false,    // sem autoplay, ou ajuste se quiser
      perView: 4,
      gap: 0,
      breakpoints: {
        992: { perView: 3 },
        768: { perView: 2 },
        576: { perView: 1 },
      },
    }).mount();
  }

  // 3) Slider de Destaques
  const destaques = document.querySelector('.glide--destaques');
  if (destaques) {
    new Glide(destaques, {
      type: 'carousel',
      autoplay: false,
      perView: 4,
      gap: 24,
      breakpoints: {
        992: { perView: 3 },
        768: { perView: 2 },
        576: { perView: 1 },
      },
    }).mount();
  }


  // 4) Thumbnails Pagina de produto

  const olThumbs = document.querySelector('ol.flex-control-nav.flex-control-thumbs');
  if (olThumbs) {
    // 1) criar o wrapper principal
    const glideWrapper = document.createElement('div');
    glideWrapper.className = 'glide glide--thumbs';

    // 2) criar o track
    const track = document.createElement('div');
    track.className = 'glide__track';
    track.setAttribute('data-glide-el', 'track');

    // 3) mover o <ol> pra dentro do track e adicionar a classe de slides
    olThumbs.parentNode.insertBefore(glideWrapper, olThumbs);
    glideWrapper.appendChild(track);
    track.appendChild(olThumbs);
    olThumbs.classList.add('glide__slides');

    // 4) criar as setas
    const arrows = document.createElement('div');
    arrows.className = 'glide__arrows';
    arrows.setAttribute('data-glide-el', 'controls');
    arrows.innerHTML = `
      <button class="glide__arrow glide__arrow--left"  data-glide-dir="<">‹</button>
      <button class="glide__arrow glide__arrow--right" data-glide-dir=">">›</button>
    `;
    glideWrapper.appendChild(arrows);

    // 5) inicializar o Glide
    new Glide(glideWrapper, {
      type: 'carousel',
      gap: 10,
      perView: 4,
      breakpoints: {
        768: { perView: 3 }
      }
    }).mount();
  }



});
